import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const alerts = createWorkspaceResourceApi('compliance-alerts')

const multipart = { 'Content-Type': 'multipart/form-data' }

export const complianceAlertsApi = {
  list: alerts.list,
  get: alerts.get,
  create: (workspaceId, payload) =>
    apiFetch(alerts.path(workspaceId), { method: 'POST', body: payload, headers: multipart }),
  update: (workspaceId, alertId, payload) =>
    apiFetch(`${alerts.path(workspaceId)}/${alertId}`, {
      method: 'PUT',
      body: payload,
      headers: payload instanceof FormData ? {} : { 'Content-Type': 'application/json' },
    }),
  updateStatus: (workspaceId, alertId, payload) =>
    apiFetch(`${alerts.path(workspaceId)}/${alertId}/status`, { method: 'PUT', body: payload }),
  bulkUpdateStatus: (workspaceId, payload) =>
    apiFetch(`${alerts.path(workspaceId)}/bulk-update-status`, { method: 'POST', body: payload }),
  assignOwner: (workspaceId, alertId, payload) =>
    apiFetch(`${alerts.path(workspaceId)}/${alertId}/owner`, { method: 'PUT', body: payload }),
  addNote: (workspaceId, alertId, payload) => alerts.action(workspaceId, alertId, 'notes', payload),
  uploadFile: (workspaceId, alertId, formData) =>
    apiFetch(`${alerts.path(workspaceId)}/${alertId}/files`, {
      method: 'POST',
      body: formData,
      headers: multipart,
    }),
}
